import script from "./DrillHoleEdgeCounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrillHoleEdgeCounts.vue?vue&type=script&setup=true&lang=ts"

import "./DrillHoleEdgeCounts.vue?vue&type=style&index=0&id=629c590a&lang=scss"
import "./DrillHoleEdgeCounts.vue?vue&type=style&index=1&id=629c590a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-629c590a"]])

export default __exports__